import { render, staticRenderFns } from "./EditAward.vue?vue&type=template&id=183afd12&scoped=true"
import script from "./EditAward.vue?vue&type=script&lang=js"
export * from "./EditAward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183afd12",
  null
  
)

export default component.exports